import type { Tab } from "./app-view-state.js";
import { t } from "./i18n.ts";

const TAB_TITLES: Record<Tab, string> = {
  eadDiagramStandard: "tab.eadDiagramStandard",
  eadSkills: "tab.eadSkills",
  exploreTypes: "tab.exploreTypes",
  projects: "tab.projects",
  runs: "tab.runs",
  closedRuns: "tab.closedRuns",
  skills: "tab.skills",
  chat: "tab.chat",
  chatMinimal: "tab.chatMinimal",
  generateChat: "tab.generateChat",
};

export function titleForTab(tab: Tab): string {
  return t(TAB_TITLES[tab] ?? String(tab));
}

export function subtitleForTab(_tab: Tab): string {
  return "";
}
